import { render, staticRenderFns } from "./main-image-banner.vue?vue&type=template&id=bcd5bfae&scoped=true&"
import script from "./main-image-banner.vue?vue&type=script&lang=js&"
export * from "./main-image-banner.vue?vue&type=script&lang=js&"
import style0 from "./main-image-banner.vue?vue&type=style&index=0&id=bcd5bfae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd5bfae",
  null
  
)

export default component.exports